export const WITHOUT_VAT_LABEL = 'Без НДС'

export const directVatRateOptions = [
  { label: '22%', value: 0.22 },
  { label: '10%', value: 0.1 },
  { label: '7%', value: 0.07 },
  { label: '5%', value: 0.05 },
  { label: '0%', value: 0 },
  { label: WITHOUT_VAT_LABEL, value: 0 }
]

export const paymentVatRateOptions = directVatRateOptions.map((option) => ({
  ...option,
  label: option.label === WITHOUT_VAT_LABEL ? option.label : `НДС ${option.label}`
}))

export const advanceVatRateOptions = [
  { label: '22/122', value: 122 / 22 },
  { label: '10/110', value: 110 / 10 },
  { label: '7/107', value: 107 / 7 },
  { label: '5/105', value: 105 / 5 },
  { label: '0%', value: 0 },
  { label: WITHOUT_VAT_LABEL, value: 0 }
]

export function vatOptionLabel(option) {
  if (option && typeof option === 'object') {
    return option.label || ''
  }
  return option === null || option === undefined ? '' : String(option)
}

export function vatOptionValue(option) {
  const rawValue = option && typeof option === 'object' ? option.value : option
  if (typeof rawValue === 'string' && rawValue.includes('%')) {
    const percentMatch = rawValue.match(/(\d+(?:[.,]\d+)?)\s*%/)
    const percent = percentMatch ? Number.parseFloat(percentMatch[1].replace(',', '.')) : Number.NaN
    return Number.isFinite(percent) ? percent / 100 : Number.NaN
  }
  if (option && typeof option === 'object') {
    return Number.parseFloat(option.value)
  }
  return Number.parseFloat(option)
}

export function isWithoutVatOption(option) {
  return vatOptionLabel(option) === WITHOUT_VAT_LABEL
}

export function vatRateLabel(option) {
  if (option && typeof option === 'object' && option.rateLabel) {
    return option.rateLabel
  }
  return vatOptionLabel(option).replace(/^НДС\s+/i, '')
}

export function calculatePaymentVatAmount(amount, option) {
  if (isWithoutVatOption(option)) {
    return 0
  }
  const sum = Number.parseFloat(amount)
  const rate = vatOptionValue(option)
  if (!Number.isFinite(sum) || !Number.isFinite(rate)) {
    return 0
  }
  return sum * rate
}

export function formatPaymentVatText(amount, option) {
  if (isWithoutVatOption(option)) {
    return WITHOUT_VAT_LABEL
  }
  const vatAmount = calculatePaymentVatAmount(amount, option)
  return `В т.ч. НДС (${vatRateLabel(option)}) ${vatAmount.toFixed(2).replace('.', '-')}`
}

export function advanceVatCoefficient(option) {
  const label = vatOptionLabel(option)
  const match = label.match(/^(\d+(?:[.,]\d+)?)\/(\d+(?:[.,]\d+)?)$/)
  if (!match) {
    const optionValue = vatOptionValue(option)
    return Number.isFinite(optionValue) ? optionValue : 0
  }

  const rate = Number.parseFloat(match[1].replace(',', '.'))
  const total = Number.parseFloat(match[2].replace(',', '.'))
  return rate > 0 ? total / rate : 0
}

export function hasAdvanceVat(option) {
  return !isWithoutVatOption(option) && advanceVatCoefficient(option) > 0
}
